import {RSAA} from 'redux-api-middleware';
import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION} from "../util/constants";
import * as types from "./types";
import {handleUnauthorizedAccess} from "../util/utility";

export function chargeViewerForSession(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/charge-new?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.CHARGE_VIEWER_REQUEST, types.CHARGE_VIEWER_RECEIVE, {
                type: types.CHARGE_VIEWER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetChargeViewer = () => ({
    type: types.RESET_CHARGE_VIEWER,
    payload: null
});